export default [     
    
    // NIFTI    
    {
        name: 'volume',
        type: 'niftiFile',
        // path: 'nifti/colon/volume.nii.gz',
        // path: 'nifti/cardiac/mr_train_1014_image.nii.gz',
        path: 'nifti/cardiac/ct_train_1002_image.nii.gz',
        // path: 'nifti/cardiac/ct_train_1002_label.nii.gz',
        // path: 'nifti/cardiac/mr_train_1014_image.nii.gz',
        // path: 'nifti/cardiac/mr_train_1014_label.nii.gz',
        // path: 'nifti/head/CTA-Head-and-Neck.nii.gz',
    }, 
    
]